function Icon({ className = "" }) {
  return (
    <svg className={className} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
        <g>
          <path d="M12,12 L20,4 L20,0 L0,0 L0,4 L8,12 L8,20 L12,16 L12,12 Z"></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
